export function storeAnalyzePatternModel() {
    return {
        'date_to_type': 'current_date',
        'name': null,
        'is_private': false
    }
}
